import React, { useEffect, useState } from "react";

import {
  Button,
  Form,
  FormField,
  Input,
  Message,
  Segment,
} from "semantic-ui-react";
import { reset, resetPasswordConfirm } from "../../redux/modules/auth";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { ErrorWrap } from "../../helpers/error";
import { routes } from "../../routes";
import { StyledLinks, StyledErrorSpan } from "./styled-components";
import { t } from "../../constant/translations";

type Props = {
  error?: Object,
  reset?: Function,
  setField?: Function,
  resetPasswordConfirm: Function,
  loading: Boolean,
};

const PasswordResetConfirmComponent = ({
  error,
  reset,
  setField,
  resetPasswordConfirm,
  loading,
  match,
}: Props) => {
  const [state, setState] = useState({ formData: {} });

  useEffect(() => {
    reset();
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    resetPasswordConfirm(
      state.formData.password1,
      state.formData.password2,
      match.params.uid,
      match.params.token
    );
  };

  const handleSetField = (name, value) => {
    const data = state.formData || {};
    if (value) {
      data[name] = value;
    } else {
      delete data[name];
    }
    setState({ formData: data });
  };

  const errorWrap = ErrorWrap.fromError(error);
  return (
    <Form action="" onSubmit={onSubmit} error={errorWrap.exists()}>
      <Segment>
        <FormField>
          <Input
            name="password1"
            icon="key"
            iconPosition="left"
            placeholder={t("login.password")}
            type="password"
            error={errorWrap.has("new_password1")}
            onChange={(event) =>
              handleSetField("password1", event.target.value)
            }
          />
          {errorWrap.has("new_password1") && (
            <StyledErrorSpan>{error.get("new_password1")}</StyledErrorSpan>
          )}
        </FormField>
        <FormField>
          <Input
            name="password2"
            icon="key"
            iconPosition="left"
            placeholder={t("login.repeat_password")}
            type="password"
            error={errorWrap.has("new_password2")}
            onChange={(event) =>
              handleSetField("password2", event.target.value)
            }
          />
          {errorWrap.has("new_password2") && (
            <StyledErrorSpan>{errorWrap.get("new_password2")}</StyledErrorSpan>
          )}
        </FormField>
        <StyledLinks>
          <Link to={routes.authLogin}>{t("login.tologin")}</Link>
        </StyledLinks>

        <Message error content={errorWrap.getGlobal()} />
        <Button
          type="submit"
          fluid
          size="large"
          loading={loading}
          disabled={!(state.formData.password1 && state.formData.password2)}
        >
          {t("labels.save")}
        </Button>
      </Segment>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.auth.error,
    userKey: state.auth.userKey,
    loading: state.auth.loggingIn,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const resetConfirmAndRedirect = (...data) => {
    return (dispatch) => {
      return dispatch(resetPasswordConfirm(...data)).then(() =>
        ownProps.history.push(routes.authLogin)
      );
    };
  };

  return bindActionCreators(
    { resetPasswordConfirm: resetConfirmAndRedirect, reset },
    dispatch
  );
};

export const PasswordResetConfirm = connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordResetConfirmComponent);
